import { Injectable } from '@angular/core';
import { ExactSyncTimeService } from '@macs-frontend/core/services/exact-sync-time.service';
import { BaseStore } from '@macs-frontend/core/store/base.store';
import { makeObservable } from '@macs-frontend/core/utils/mobx';
import { UUID } from '@macs-frontend/core/utils/uuid';
import { ClientsApiService } from '@macs-frontend/features/company-management/manage/services/clients-api.service';
import { Client } from '@macs-frontend/features/shared';
import { action, observable } from 'mobx-angular';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExactClientSyncService extends BaseStore {
  @observable
  showSpinner = false;

  @observable
  loadingFailed = false;

  readonly clientLoaded$ = new Subject<Client>();
  requestSubscription?: Subscription;

  constructor(
    readonly clientsApiService: ClientsApiService,
    readonly exactSyncTimeService: ExactSyncTimeService,
  ) {
    super();
    makeObservable(this);
  }

  @action
  loadClient(uuid: UUID) {
    if (!this.exactSyncTimeService.needsSync(uuid)) {
      return;
    }
    this.loadingFailed = false;
    this.showSpinner = true;
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
    this.requestSubscription = this.clientsApiService.getClient(uuid, true).subscribe(
      response => {
        this.clientLoaded$.next(response.data);
        this.showSpinner = false;
        this.exactSyncTimeService.markAsSynced(uuid);
      },
      error => {
        this.showSpinner = false;
        this.loadingFailed = true;
      },
    );
  }
}
